import ProductCard from "./ProductCard.jsx";
import {Carousel} from "antd";
import PropTypes from "prop-types";

const BasketRecommendation = ({ basketRecommendations, products }) => {

    const matchingProducts = basketRecommendations?.products
        ?.map((recProduct) => {
            const matched = products.find((p) => p.artikul === recProduct.code);
            if (matched) {
                return {
                    ...matched,
                    discount: recProduct.discount,
                    discount_title: recProduct.discount_title,
                };
            }
            return null;
        })
        .filter(Boolean);

    return (
        <div>
            {basketRecommendations?.name && (
                <div
                    className="py-2 mx-auto text-2xl text-center font-extrabold mb-5 break-words whitespace-normal"
                >
                    {basketRecommendations.name}
                </div>
            )}

            <Carousel autoplay={true} dots={false} autoplaySpeed={3000} infinite={true}>
                {matchingProducts.map((product) => (
                    <div key={product.id}>
                        <ProductCard isCart={true} product={product} buttonBackgroundColor={"#E52B50"} buttonBorderColor={"#E52B50"} />
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

BasketRecommendation.propTypes = {
    basketRecommendations: PropTypes.shape({
        name: PropTypes.string,
        products: PropTypes.arrayOf(
            PropTypes.shape({
                code: PropTypes.string,
                discount: PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.number
                ])
            })
        )
    }),
    products: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            artikul: PropTypes.string.isRequired,
            qty: PropTypes.number.isRequired,
            price: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            image: PropTypes.string
        })
    ).isRequired
};

export default BasketRecommendation;
